import React from 'react'
import './Portfolio.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import Sopeo from "../../img/sopeo.jpeg";
import Story from "../../img/story.jpeg";
import Image from "../../img/image.jpeg";
import virtual_assistance from "../../img/virtual_assistance.jpeg";
import 'swiper/css';
import { themeContext } from '../../Context'
import { useContext } from 'react'

const Portfolio = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode

    return (
        <div className="portfolio" id="Portfolio">
            {/* heading */}
            <span style={{color: darkMode? 'white': ''}}>Recent Projects</span>
            <span>Portfolio</span>
            {/* slider */}
            <Swiper 
            spaceBetween={30}
            slidesPerView={3}
            grabCursor={true}
            className="portfolio-slider"
            >
                <SwiperSlide>
                    <a href="https://sopeo.in" target="_blank"><img src={Sopeo} alt="" /></a>
                </SwiperSlide>
                <SwiperSlide>
                <a href="https://github.com/choudhary2001/Story" target="_blank"><img src={Story} alt="" /></a>
                </SwiperSlide>
                <SwiperSlide>
                <a href="https://github.com/choudhary2001/image" target="_blank"><img src={Image} alt="" /></a>
                </SwiperSlide>
                <SwiperSlide>
                   <a href="https://github.com/choudhary2001/virtual_assistant_python" target="_blank"> <img src={virtual_assistance} alt="" /></a>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}

export default Portfolio